// Work = professional client work
export const workProjects = [
  {
    title: '10X Health System',
    client: '10X Health System',
    kind: 'CLIENT WORK',
    description: 'Shopify store, internal apps, and integrations for a health optimization brand.',
    tags: ['SHOPIFY', 'FULL-STACK'],
    live: 'https://shop.10xhealthsystem.com',
    image: 'https://minters.s3.us-west-2.amazonaws.com/10xhealth1.png',
    imageBank: [
      'https://minters.s3.us-west-2.amazonaws.com/10xhealth.png',
      'https://minters.s3.us-west-2.amazonaws.com/10x2.gif',
      'https://minters.s3.us-west-2.amazonaws.com/10x1.gif',
    ],
    status: 'LIVE',
    details: `I've had the opportunity to work as the lead Shopify developer and subject matter expert for 10X Health System working to improve both operational features as well as the user experience for their customers.

1. Streamlined appointment scheduling by developing a Shopify Checkout UI extension and integrating Calendly, allowing customers to book services directly after purchase.

2. Optimized ad tracking and analytics through a custom Meta Pixel using Shopify Customer events, supporting advanced reporting with the Hyros Ad Platform.

3. Revamped site design and user experience with Shopify Liquid, HTML, and CSS, introducing key features such as a custom modal for capturing additional customer information, a subscription confirmation modal, custom landing pages, and a cart drawer to replace the cart page.

4. Enhanced theme architecture by implementing Shopify sections and blocks, enabling effortless template customization and reducing development overhead.

5. Implemented integrations with Hyros, Funnel.io, Meta, Onetrust, and Appstle Subscriptions and Memberships.`,
  },
  {
    title: 'Thrive Causemetics',
    client: 'Thrive Causemetics',
    kind: 'CLIENT WORK',
    description: 'Shopify store plus the internal apps and integrations that keep it running.',
    tags: ['SHOPIFY', 'FULL-STACK'],
    live: 'https://www.thrivecausemetics.com',
    image: './images/thrivecausemetics.png',
    imageBank: ['./images/thrivecausemetics.png'],
    status: 'LIVE',
    details: `I had the privilege of joining the Ecommerce team at Thrive Causemetics, one of Shopify's premier stores and a leading D2C beauty brand.

1. Link Builder: An internal Shopify app using React, Polaris, Admin API, and Storefront API that empowers the Customer Experience team to craft custom URLs — launched within my first 30 days.

2. Free Gift with Purchase: A multi-tier gift-with-purchase program using Contentful CMS, enabling customers to select product variants or have single-variant items automatically added to their carts.

3. Shade Finder: A feature allowing customers to filter product shades based on various factors, built with Contentful CMS, Shopify Liquid, and Vanilla JavaScript.

4. Dual Branding: A second brand experience with shared cart functionality, unique styles/fonts/colors via CSS variables, and a new product display page with an image grid and custom image slider.

5. Express API Server: An express server for third-party integrations including Cordial, Postscript, and Yotpo.

6. Rebuy Integration: A comprehensive cart revamp integrating the Rebuy Smart Cart — resulting in a revenue surge of $6,000,000 with a forecasted uptick of $30,000,000 for the year.`,
  },
  {
    title: 'Fordays',
    client: 'FYC Labs',
    kind: 'CLIENT WORK',
    description: 'Shopify theme and custom app powering a circular-fashion brand and its rewards system.',
    tags: ['SHOPIFY', 'FULL-STACK'],
    live: 'https://www.fordays.com',
    image: './images/fordays.png',
    imageBank: ['./images/fordays.png'],
    status: 'LIVE',
    details: `One of my inaugural professional development endeavors. I played a pivotal role in crafting a contemporary Shopify Theme and was instrumental in architecting their user rewards system, "Closet Cash."

1. Item-Based Earning: Every product had an associated Closet Cash value. Should a customer decide they no longer desired the item, they could return it to Fordays and receive digital credits.

2. Take Back Bag: Customers could purchase a Take Back Bag, fill it with washed clothing items, and ship them back for Closet Cash. Built with React, Express, TypeScript, and Google Firebase.

3. QR Code Integration: A unique QR code on each bag allowed customers to initiate returns and our shipping team to process items seamlessly.

4. Spearheaded multiple sales promotions during Black Friday, Cyber Monday, and the festive season — mystery discounts, tiered free gifts, custom slash discounts, and gated sales experiences.

Favorite Feature: The QR code-based scanning and the complete Take Back Bag redemption journey.`,
  },
  {
    title: "Knowin' What's Growin'",
    client: 'FYC Labs',
    kind: 'CLIENT WORK',
    description: 'Interactive learning app for California 4th graders to explore locally grown crops.',
    tags: ['REACT', 'FULL-STACK'],
    live: 'https://knowinwhatsgrowin.com',
    image: './images/kwg.png',
    imageBank: [
      './images/kwg.png',
      './images/kwg-1.png',
      './images/kwg-2.png',
      './images/kwg-3.png',
      './images/kwg-4.png',
    ],
    status: 'LIVE',
    details: `A learning app that serves as an extension for 4th grade classroom curriculum, helping students learn about crops grown throughout California.

1. Interactive State Map: Students navigate a map of California built using GeoJSON, react-simple-maps, and Preact Signals for state management.

2. Lessons & Recipes: Students can view lessons about crops and view/print recipes that include the crop.

3. Quizzes: After completing lessons for all crops in a county, students take a quiz with multiple choice and matching questions.

4. Badges: After completing quizzes and lessons, students earn badges. Progress is tracked in their profile.

5. Parent Resources: A resources page where parents can view all lessons and recipes and download generated PDFs — built using a Google Cloud function with Node.js and Puppeteer.

6. React headless setup with WordPress CMS for all content management.`,
  },
  {
    title: 'Holostars',
    client: 'FYC Labs + Chainstarters',
    kind: 'CLIENT WORK',
    description: 'NFT marketplace for college athletes — minting, wallet connect, and live drop UI.',
    tags: ['NFT', 'FRONTEND'],
    live: 'https://www.holostars.com',
    image: './images/holostars.gif',
    imageBank: ['./images/holostars.gif'],
    status: 'LIVE',
    details: `I led the frontend development of an NFT Marketplace tailored for College Athletes, using React, ethers.js, useDapp, recharts, and Bootstrap.

Users could sign up using either their Metamask wallet or a traditional email address. For email sign-up, we hosted their wallet through Magic Link.

Favorite Feature: Magic Link's integration with various social profiles allowed users to mint an NFT directly using their GitHub profile.

Note: The live version has since been converted into a Shopify store.`,
  },
  {
    title: 'XIX Palms',
    client: 'Independent',
    kind: 'CREATIVE DIRECTION',
    description: "Full branding, creative direction, and identity system for a women's clothing line.",
    tags: ['BRANDING', 'CREATIVE'],
    live: 'https://www.xixpalms.com/',
    image: '/images/xixpalms-im1.jpg',
    imageBank: [
      '/images/xixpalms-im1.jpg',
      'https://minters.s3.us-west-2.amazonaws.com/adz-xix-1.jpg',
      'https://minters.s3.us-west-2.amazonaws.com/nellie-1-160.jpg',
      'https://minters.s3.us-west-2.amazonaws.com/trees-1022.jpg',
      'https://minters.s3.us-west-2.amazonaws.com/nora.jpg',
      'https://minters.s3.us-west-2.amazonaws.com/xix105.jpg',
      'https://minters.s3.us-west-2.amazonaws.com/xix104.jpg',
      'https://minters.s3.us-west-2.amazonaws.com/xix102.jpg',
      'https://minters.s3.us-west-2.amazonaws.com/adz-xix-2.jpg',
    ],
    status: 'LIVE',
    details: `From a scribble on paper to a fashion sensation — I transformed an idea into a women's clothing line that was in over 110 retail doors across the U.S., Canada, Japan, and Australia.

- Developed the overall brand strategy including all logos, brand story, and maintained creative direction.
- 2015–2016 growth of 2.74x with GM of 52% and Profit of 10.7%
- 2016–2017 growth of 3.5x with GM of 81% and Profit of 31%
- Built an Instagram Following from zero to 40k at time of leaving.
- Built an email list from zero to ~10k active subscribers.
- Built a wholesale business covering the U.S., Canada, Australia, and Japan. Major accounts included Anthropologie, Everything But Water, and United Arrows (Japan).
- Handled all product and lifestyle photography for the brand's website.`,
  },
  {
    title: 'Ultimate Water Creations',
    client: 'Houzz',
    kind: 'DESIGN',
    description: 'Marketing site built for a luxury pool builder in Los Angeles.',
    tags: ['WEB', 'DESIGN'],
    live: 'https://ultimatewatercreations.net/',
    image: './images/ultimatewatercreations.jpg',
    imageBank: ['https://pace-pusher.s3-us-west-1.amazonaws.com/ultimatewatercreations.png'],
    status: 'LIVE',
    details: `A website designed while working at Houzz. My role was to jump on Zoom calls with Houzz Pro users, understand what they were trying to accomplish with their website, and design one within our internal website builder.

This was for a customer who built high-end custom pools for families in Los Angeles.`,
  },
  {
    title: 'Jenny Guza Designs',
    client: 'Houzz',
    kind: 'DESIGN',
    description: 'Portfolio site built for an interior designer in Tennessee.',
    tags: ['WEB', 'DESIGN'],
    live: 'https://jennyguzadesigns.com/',
    image: './images/jenny-2.jpg',
    imageBank: ['https://pace-pusher.s3-us-west-1.amazonaws.com/jenny-2.png'],
    status: 'LIVE',
    details: `A website designed while working at Houzz. My role was to jump on Zoom calls with Houzz Pro users, understand what they were trying to accomplish with their website, and design one within our internal website builder.

This was for an interior designer working with families in Tennessee.`,
  },
  {
    title: 'Morgan HR',
    client: 'FYC Labs',
    kind: 'DESIGN',
    description: 'Company site for an HR consulting firm with three cohesive sub-brands.',
    tags: ['WEB', 'DESIGN'],
    live: 'https://morganhr.com/',
    image: '/images/morganHR.png',
    imageBank: ['/images/morganHR.png'],
    status: 'LIVE',
    details: `A WordPress site designed for a Human Resources Consulting Firm. They have several brands and wanted a cohesive story and website that showed how all three brands worked together.`,
  },
]

// Lab = personal projects + hackathons
export const labProjects = [
  {
    title: 'Adventure Time',
    client: 'Personal',
    kind: 'PERSONAL PROJECT',
    description: 'AI-powered choose-your-own-adventure game where every story is unique.',
    tags: ['AI', 'FULL-STACK'],
    live: 'https://adventuretime.cool',
    image: './images/advtime.png',
    imageBank: ['./images/advtime.png', './images/advtime_002.png', './images/advtime_003.png'],
    status: 'LIVE',
    details: `I loved reading choose your own adventure books as a kid and wanted to recreate the experience. Adventure Time is a choose-your-own-adventure text-based game where each story is crafted by AI, creating a unique tale where the player's choices shape the outcomes — no two stories are exactly alike.

Once the player clicks begin, they enter the genre they'd like the story set in. This can be as simple as "western" or as creative as they want.

After selecting a genre, the story begins. They're given the first part and several choices. If they select "view inventory," they see any items collected during the journey.`,
  },
  {
    title: 'Haiku Hugo',
    client: 'Personal',
    kind: 'PERSONAL PROJECT',
    description: 'An AI bot that writes haikus on any subject and posts them to Twitter.',
    tags: ['AI', 'PERSONAL'],
    live: 'https://www.haikuhugo.com',
    image: 'https://minters.s3.us-west-2.amazonaws.com/hh.gif',
    imageBank: ['https://minters.s3.us-west-2.amazonaws.com/hh.gif'],
    status: 'LIVE',
    details: `I was inspired to experiment with AI, leading me to develop a unique bot capable of crafting haikus based on any given subject. Once a haiku is generated, it's automatically posted to Twitter.

The process involves an API endpoint that takes user input, prompts ChatGPT to compose a haiku on the specified topic, and then posts it using Twitter's API.`,
  },
  {
    title: 'BA Kanban',
    client: 'MintBean JS Olympics',
    kind: 'HACKATHON',
    description: 'Weekend-hackathon kanban board — 2nd place among international teams.',
    tags: ['HACKATHON', 'REACT'],
    live: 'https://demo-badass-kanban.adambotma.xyz/',
    github: 'https://github.com/adam-botma/hackathon-badass',
    image: './images/ba-kanban.gif',
    imageBank: ['./images/ba-kanban.gif'],
    status: 'LIVE',
    details: `At a 48-hour hackathon by Mint Bean, we faced the challenge of crafting a kanban board using only frontend technologies. Leveraging React, local storage, Material UI, and a few npm packages, our team clinched 2nd place among a multitude of international teams.

Favorite Feature: I incorporated a confetti animation for completed tasks, which might have given us an edge for that 2nd place finish.`,
  },
  {
    title: 'Code Notes',
    client: 'Personal',
    kind: 'PERSONAL PROJECT',
    description: 'Notes, docs, flashcards, and code snippets in one place for people learning to code.',
    tags: ['REACT', 'PERSONAL'],
    live: 'https://code-notes.adambotma.xyz/',
    github: 'https://github.com/adam-botma/class-notes',
    image: './images/code-notes.png',
    imageBank: [
      'https://user-images.githubusercontent.com/61361957/98852563-b2a07600-240c-11eb-86db-9f7855a2576d.gif',
    ],
    status: 'LIVE',
    details: `A dynamic web application for students learning to code who want to organize their notes, documentation resources, flashcards, and code examples all in one place.`,
  },
  {
    title: 'R + M Battle Royal',
    client: 'Personal',
    kind: 'PERSONAL PROJECT',
    description: 'Card game à la War, built on two public APIs over a hackathon weekend.',
    tags: ['API', 'GAME'],
    live: 'https://rm-battle-royale.adambotma.xyz/',
    github: 'https://github.com/adam-botma/rm-battle-royale',
    image: './images/Rick-Morty-battle.png',
    imageBank: [
      './images/Rick-Morty-battle.png',
      'https://minters.s3.us-west-2.amazonaws.com/rm-splash.png',
      'https://minters.s3.us-west-2.amazonaws.com/rmplay.gif',
    ],
    status: 'LIVE',
    details: `A hackathon project utilizing data from the Rick and Morty and another public API to create a card game similar to classic War. Players battle with character cards, comparing stats to determine the winner of each round.`,
  },
  {
    title: 'Learn Hawaiian Memory Match',
    client: 'Personal',
    kind: 'PERSONAL PROJECT',
    description: 'Card match game where players pair English words with their Hawaiian counterparts.',
    tags: ['GAME', 'PERSONAL'],
    live: 'https://memory-match.adambotma.xyz/',
    github: 'https://github.com/adam-botma/learn-hawaiian-memory-match',
    image: 'https://minters.s3.us-west-2.amazonaws.com/mm2.gif',
    imageBank: [
      'https://raw.githubusercontent.com/adam-botma/learn-hawaiian-memory-match/master/assets/images/hawaii-mem-match-sml.gif',
      'https://raw.githubusercontent.com/adam-botma/learn-hawaiian-memory-match/master/assets/images/Instructions.png',
      'https://minters.s3.us-west-2.amazonaws.com/game-demo.gif',
    ],
    status: 'LIVE',
    details: `A fun memory match card game where users match a card containing an English word (and helpful image) with the corresponding Hawaiian word card.

To help users learn which cards match, each matching card set has the same colored background and icon image.`,
  },
]
